<div #loadingScreen class="loading-screen"><mat-progress-spinner mode="indeterminate"></mat-progress-spinner></div>